import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import WhatsAppPanel from './components/WhatsAppPanel';
import SubjectMarksSender from './components/SubjectMarksSender';
import AllSubjectMarksSender from './components/AllSubjectMarksSender';
import ManualSend from './components/ManualSend';
import AttendanceTab from './components/AttendanceTab';
import PdfTools from './components/PdfTools';
import { schoolAPI } from './api';
import { BookOpen, LayoutGrid, MessageSquare as MessageSquareText, UserCheck, FileText } from 'lucide-react';

const TABS = [
  { id: 'subject', label: 'Subject Wise Marks', icon: <BookOpen size={16} /> },
  { id: 'allsubjects', label: 'All Subject Marks', icon: <LayoutGrid size={16} /> },
  { id: 'manual', label: 'Manual Send', icon: <MessageSquareText size={16} /> },
  { id: 'attendance', label: "Student's Attendance", icon: <UserCheck size={16} /> },
  { id: 'pdftools', label: 'PDF Tools', icon: <FileText size={16} /> },
];

function getSessionId() {
  let sid = localStorage.getItem('wa_session_id');
  if (!sid) {
    sid = 'session_' + Math.random().toString(36).substring(2, 10);
    localStorage.setItem('wa_session_id', sid);
  }
  return sid;
}

export default function App() {
  const [activeTab, setActiveTab] = useState('subject');
  const [schoolName, setSchoolName] = useState('');
  const [sessionId] = useState(getSessionId);

  useEffect(() => {
    schoolAPI.get()
      .then(res => setSchoolName(res.data.school_name || ''))
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 to-blue-50">
      <Header schoolName={schoolName} onSchoolNameChange={setSchoolName} />

      <div className="max-w-screen-2xl mx-auto px-4 py-5">
        <div className="flex gap-5">
          {/* Left Panel - WhatsApp */}
          <aside className="w-72 shrink-0 hidden lg:block">
            <WhatsAppPanel sessionId={sessionId} />
          </aside>

          {/* Main Content */}
          <main className="flex-1 min-w-0">
            {/* Tab Navigation */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-200 mb-5 overflow-hidden">
              <div className="flex overflow-x-auto">
                {TABS.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center gap-2 px-5 py-3.5 text-sm font-semibold whitespace-nowrap transition-all border-b-2 flex-1 justify-center ${
                      activeTab === tab.id
                        ? 'border-blue-600 text-blue-700 bg-blue-50'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    <span className={activeTab === tab.id ? 'text-blue-600' : 'text-gray-400'}>
                      {tab.icon}
                    </span>
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Mobile WhatsApp Panel */}
            <div className="lg:hidden mb-5">
              <WhatsAppPanel sessionId={sessionId} />
            </div>

            {/* Tab Content */}
            <div>
              {activeTab === 'subject' && (
                <SubjectMarksSender sessionId={sessionId} schoolName={schoolName} />
              )}
              {activeTab === 'allsubjects' && (
                <AllSubjectMarksSender sessionId={sessionId} schoolName={schoolName} />
              )}
              {activeTab === 'manual' && (
                <ManualSend sessionId={sessionId} />
              )}
              {activeTab === 'attendance' && (
                <AttendanceTab sessionId={sessionId} schoolName={schoolName} />
              )}
              {activeTab === 'pdftools' && (
                <PdfTools />
              )}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
